<!-- <div class="bgColor p-3">
  <div>
    <div class="row m-0">
      <div class="col-md-6">
        <div *ngIf="options['info']?.type" class="invoiceType">
          <small class="text-left"><b>{{options['info']?.type}}</b></small>
        </div>
      </div>
      <div class="col-md-6">
        <div class="">
          <small class="text-right"> {{options['info']?.dateOn | date}}</small>
        </div>
      </div>
    </div>
  </div>


  <div class="row mt-2">
    <div class="col-md-9">
      <div class="row">
        <div>
          <i class="ri-checkbox-circle-fill" style="color: green; font-size: large;"></i>
        </div>
        <div class="ml-2">
          <div *ngIf="message && !options.enableHtml" role="alert" aria-live="polite" class="custom-message"
          [class]="options.messageClass" [attr.aria-label]="message">
          <b>Invoice no : {{ message }} </b>
        </div>
        <div *ngIf="options['info']?.printedBy" role="alert" aria-live="polite" class="custom-message">
          <small> Printed By : {{options['info']?.printedBy}}</small>
        </div>
        </div>
      </div>
      

    </div>
    <div class="col-md-3">
      <div class="row" *ngIf="options['info']?.type">
        <div *ngFor="let btn of options['buttons']" class="col-3 text-right">

          <div class="mx-2">
            <small> <a class="btn btn-sm button" (click)="action(btn)">
                {{btn.title}}
              </a>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->




<div class="bg-gray custom-toas">
  <div>
    <div class="row mb-2">
      <div class="col-md-6">
        <div *ngIf="options['info']?.type">
          <small class="tax-invoice">{{options['info']?.type}}</small>
        </div>
      </div>

      <div class="col-md-6 text-right">
        <div>
          <small>{{options['info']?.dateOn | date}}</small>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-md-9">
        <div class="d-flex">
          <div>
            <i class="ri-checkbox-circle-fill"></i>
          </div>
          <div *ngIf="message">
            <h6 *ngIf="options['info']?.type ==='POS Checks' " class="m-0">Check no :{{ options['info']?.message }}</h6>
            <h6 *ngIf="options['info']?.type !=='POS Checks' " class="m-0">Invoice no :{{ options['info']?.message }}</h6>
            <small *ngIf="options['info']?.printedBy"> Printed by :{{options['info']?.printedBy}}</small>
          </div>
        </div>
      </div>
      <div class="col-md-3 my-auto" *ngIf="options['info']?.type">
        <div class="text-right" *ngFor="let btn of options['buttons']">
          <span class="badge badge-secondary cursor-pointer" (click)="action(btn)">Print</span>
          <!-- <button class="btn btn-primary px-3 py-1" (click)="action(btn)">print</button> -->
        </div>
      </div>
    </div>
  </div>
</div>